import { RecursivePartial } from '../base';
import { IdActive } from './id-active';

export class IdActiveJanusId extends IdActive {
    janusId?: number;

    constructor(json?: RecursivePartial<IdActiveJanusId>) {
        super(json);
        this.parseIdActiveJanusId(json || {});
    }

    parse(json: RecursivePartial<IdActiveJanusId>): IdActiveJanusId {
        super.parse(json);
        this.parseIdActiveJanusId(json);
        return this;
    }

    private parseIdActiveJanusId(json: RecursivePartial<IdActiveJanusId>): void {
        IdActiveJanusId.assignFields<IdActiveJanusId>(this, json, ['janusId']);
    }
}
